import { defineStore } from "pinia";

export const useListFilters = defineStore("listFilters", {
  state: () => ({
    doctorFilter: "" as string,
    patientFilter: "" as string,
    doctorRows: 5 as number,
    patientRows: 5 as number,
  }),
  actions: {
    setDoctorFilter(query: string) {
      this.doctorFilter = query;
    },
    clearDoctorFilter() {
      this.doctorFilter = "";
    },
    setPatientFilter(query: string) {
      this.patientFilter = query;
    },
    clearPatientFilter() {
      this.patientFilter = "";
    },
    setDoctorRows(rows: number) {
      this.doctorRows = rows;
    },
    setPatientRows(rows: number) {
      this.patientRows = rows;
    },
  },
});
